import React from 'react'
import { ParticipantsList } from './list/page'

export const Bonus150ParticipantsPage = () => {
  return <ParticipantsList />
}
